module.exports = __webpack_public_path__ + "cd455783/img/trash-icon.ff8201c7.svg";